module.exports = __webpack_public_path__ + "img/Slovakia.0f1cc69d.png";